import { FC } from "react";
import { useTranslation } from "react-i18next";

import { CaptionedLoader } from "@ryde/controls";

import { LiveMapAutofitLoaderStyled } from "./live-map.map.autofit-loader.styled";

export const LiveMapAutofitLoader: FC = () => {
  const { t } = useTranslation();

  return (
    <LiveMapAutofitLoaderStyled>
      <CaptionedLoader caption={`${t("ui.LOADING_MAP_DATA")}...`} />
    </LiveMapAutofitLoaderStyled>
  );
};
